function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.59999 2.82667C7.05888 2.71926 7.5287 2.66557 7.99999 2.66667C12.6667 2.66667 15.3333 8.00001 15.3333 8.00001C14.9286 8.75708 14.446 9.46983 13.8933 10.1267M9.41332 9.41334C9.23022 9.60984 9.00942 9.76744 8.76409 9.87675C8.51876 9.98607 8.25392 10.0448 7.98538 10.0496C7.71684 10.0543 7.4501 10.0049 7.20106 9.90433C6.95203 9.80374 6.7258 9.65403 6.53589 9.46411C6.34597 9.27419 6.19625 9.04797 6.09566 8.79893C5.99507 8.5499 5.94567 8.28315 5.95041 8.01461C5.95515 7.74607 6.01393 7.48124 6.12324 7.2359C6.23255 6.99057 6.39016 6.76977 6.58666 6.58667M11.96 11.96C10.8204 12.8287 9.43273 13.3099 7.99999 13.3333C3.33332 13.3333 0.666656 8.00001 0.666656 8.00001C1.49592 6.4546 2.64608 5.10441 4.03999 4.04001L11.96 11.96Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.666656 0.666656L15.3333 15.3333",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.51a14bc4.svg";
export { ForwardRef as ReactComponent };